import Button from "app/components/button/button";
import { useTheme } from "app/shared";
import { FC, useState } from "react";
import styles from "./CaseOpener.module.scss";

interface TwitterRepostModalProps {
  onClose: () => void;
}

const TwitterRepostModal: FC<TwitterRepostModalProps> = ({ onClose }) => {
  const { theme } = useTheme();
  const [tweetPosted, setTweetPosted] = useState(false);

  const handleTweetNow = () => {
    const text = `Spinning the Fortune Wheel on @Alphamind_labs 🎡
NFTs, nodes, stablecoins & more.
➜ https://app.alphamind.co/dashboard`;
    const twitterShareUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(
      text
    )}`;
    window.open(twitterShareUrl, "_blank");
    setTweetPosted(true);
  };

  const handleClaimOnDiscord = () => {
    const discordSupportUrl =
      "https://discord.com/channels/1239986351848296499/1239986353534406793";
    window.open(discordSupportUrl, "_blank");
  };

  return (
    <div className={styles.modal}>
      <div
        className={`${styles.modalContent} ${
          theme === "dark" ? styles.darkTheme : ""
        }`}
      >
        <button className={styles.modalClose} onClick={onClose}>
          ×
        </button>
        <h1 className={styles.tweetModalTitle}>🎯 Claim Your Bonus Spin</h1>
        <p className={styles.tweetDescription}>
          Share AlphaSpin with your friends and get +1 spin.
        </p>

        {!tweetPosted && (
          <div className={styles.tweetContainer}>
            <div className={styles.tweet}>
              <p className={styles.tweetInstructionTitle}>
                📝 Step 1 — Post this on X:
              </p>
              <p className={styles.tweetText}>
                Spinning the Fortune Wheel on @AlphaMind_co 🎡
              </p>
              <p className={styles.tweetText}>
                NFTs, nodes, stablecoins & more.
              </p>
              <p className={styles.tweetText}>
                ➜ https://app.alphamind.co/dashboard
              </p>
            </div>
            <div className={styles.tweetBtns}>
              <Button variant="pink" onClick={handleTweetNow}>
                Tweet Now
              </Button>
            </div>
          </div>
        )}

        {tweetPosted && (
          <div className={styles.tweetContainer}>
            <div className={styles.tweet}>
              <p className={styles.tweetInstructionTitle}>🔗 Step 2 — Done?</p>
              <p className={styles.tweetText}>
                Open a support ticket in our Discord and drop your tweet link +
                your wallet address.
              </p>
              <p className={styles.tweetText}>
                💡 This is a temporary manual flow. Once we upgrade the system,
                spins will be claimed automatically.
              </p>
            </div>
            <div className={styles.tweetBtns}>
              <Button variant="outlined" onClick={handleClaimOnDiscord}>
                Claim Spin on Discord
              </Button>
            </div>
          </div>
        )}

        <p className={styles.tweetText}>
          🛠️ Manual flow for now – automated soon.
        </p>
      </div>
    </div>
  );
};

export default TwitterRepostModal;
